import React from 'react';

import { IDynamicComponentProps } from '../dynamic_component_props';

export interface IProps extends IDynamicComponentProps {
  jumplinkSlug?: string;

  // legacy support
  htmlContent?: string;
  contentHtml?: string;
}

export default function MarkdownSectionHTML(props: IProps) {
  const content = props.htmlContent || props.contentHtml;

  if (!content) return null;

  return (
    <div
      className="markdown-section"
      id={props.jumplinkSlug}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
